var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "h2 text-uppercase" }, [
      _vm._v(_vm._s(_vm.headline))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-2 col-6" }, [
        _c("a", { staticClass: "icon-container", attrs: { href: _vm.url1 } }, [
          _c("img", { attrs: { src: _vm.img1, alt: "Question mark icon" } })
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.txt1))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2 col-6" }, [
        _c("a", { staticClass: "icon-container", attrs: { href: _vm.url2 } }, [
          _c("img", { attrs: { src: _vm.img2, alt: "Alert triangle icon" } })
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.txt2))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2 col-6" }, [
        _c("a", { staticClass: "icon-container", attrs: { href: _vm.url3 } }, [
          _c("img", { attrs: { src: _vm.img3, alt: "Donwload icon" } })
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.txt3))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2 col-6" }, [
        _c("a", { staticClass: "icon-container", attrs: { href: _vm.url4 } }, [
          _c("img", { attrs: { src: _vm.img4, alt: "File text icon" } })
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.txt4))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4" }, [
        _c("a", { staticClass: "icon-container", attrs: { href: _vm.url5 } }, [
          _c("img", { attrs: { src: _vm.img5, alt: "Smartphone icon" } }),
          _vm._v(" "),
          _c("p", { staticClass: "ff-proxima white ml-3" }, [
            _vm._v(_vm._s(_vm.imgtxt5))
          ])
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.txt5))])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }